import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";




export const utilityNamespace = 'spartaMediaQueryUtility';





const breakpointEventName = 'BREAKPOINT_CHANGE';





const widgetResizeEventName = 'WIDGET_RESIZE';





const EVENTS = {
  [breakpointEventName]: `${breakpointEventName}.${utilityNamespace}`,
  [widgetResizeEventName]: `${widgetResizeEventName}.${utilityNamespace}`,
};

export default EVENTS;
